export default (client) => {
  return {
    leer() {
      return client.get('/extras-mg/plantillas/')
    },
    usar(tablaId, baseId, nombre) {
      return client.post(`/extras-mg/plantillas/${tablaId}/usar/`, { base_id: baseId, nombre })
    },
  }
}
